import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import OnboardingSection from '../OnboardingSection';
import { BasicPlusIcon } from '../../../../ui/Icons';

type OnboardingPhotoUploadProps = {
  onEdit: () => void;
};

const OnboardingPhotoUpload: React.FCWithChildren<OnboardingPhotoUploadProps> = ({ onEdit }) => (
  <OnboardingSection
    iconContent={(
      <Box paddingRight={8}>
        <Box
          padding={4}
          borderStyle="solid"
          borderWidth={1}
          borderColor={colors.blackInBlack}
        >
          <BasicPlusIcon
            width={18}
            height={18}
          />
        </Box>
      </Box>
    )}
    onClick={onEdit}
    label="Upload photos"
    testID="onboardingPhotoUpload"
    borderColor={colors.metal}
    borderStyle="dashed"
  />
);

export default OnboardingPhotoUpload;
